// extracted by css-extract-rspack-plugin
export default {"cls1":"Reason-cls1_Jmu","cls2":"Reason-cls2_CvH Reason-cls1_Jmu"};